// router/index.ts
import { createRouter, createWebHistory } from 'vue-router'

// 动态导入所有页面
const routes = import.meta.glob('../pages/**/*.vue')
const formattedRoutes = Object.keys(routes).map((path) => {
    const routePath = `${path.replace('../pages', '').replace('.vue', '')}`; // 处理路由路径
    const routeComponent = routes[path]; // 组件

    return {
        path: routePath,
        component: routeComponent
    };
});

// 打印路由信息
console.log('动态生成的路由:', formattedRoutes);

const router = createRouter({
    history: createWebHistory(),
    routes: formattedRoutes
});

// const router = createRouter({
//     history: createWebHistory(),
//     routes: Object.keys(routes).map((path) => ({
//         path: `/${path.replace('../pages', '').replace('.vue', '')}`, // 配置路由路径
//         component: routes[path], // 异步加载组件
//     })),
// })

// 自动跳转到指定的页面，比如首页
router.beforeEach((to, _from, next) => {
    const token = localStorage.getItem('token')

    if(!token && to.path != '/login') {
        return next(`/login?redirect=${to.fullPath}`)
    }
    return  next()  // 继续路由

})

export default router
